export default __webpack_public_path__ + "static/kamera-affbad8658465c25ad631d517de6d7fc.jpg";